import FormatImageSelection from './FormatImageSelection'

export default FormatImageSelection